import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from "../../api/auth";
import styles from './SignIn.module.css';

const SignIn = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Очистка ошибки при изменении формы
    if (error) setError('');
  };

  const validateForm = () => {
    if (!formData.email.trim()) {
      setError('Email is required');
      return false;
    }
    if (!formData.password) {
      setError('Password is required');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setLoading(true);
    setError('');

    try {
      // Отправляем данные для входа
      const credentials = {
        email: formData.email,
        password: formData.password
      };

      const response = await authAPI.signIn(credentials);
      
      console.log('Sign in successful:', response);
      
      // Перенаправление на главную страницу или dashboard после успешного входа
      navigate('/dashboard');
    } catch (err) {
      console.error('Sign in error:', err);
      
      // Обработка различных типов ошибок
      if (err.status === 401) {
        setError('Invalid email or password');
      } else if (err.status === 403) {
        setError('Your account is not activated');
      } else {
        setError(err.message || 'Sign in failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <div className={styles.formWrapper}>
          <h1 className={styles.title}>Sign in</h1>

          <form onSubmit={handleSubmit} className={styles.form}>
            {error && (
              <div className={styles.error}>
                {error}
              </div>
            )}

            <div className={styles.formGroup}>
              <label className={styles.label}>Email address</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleChange('email', e.target.value)}
                className={styles.input}
                placeholder="Enter your email"
                disabled={loading}
                required
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => handleChange('password', e.target.value)}
                className={styles.input}
                placeholder="Enter your password"
                disabled={loading}
                required
              />
            </div>

            <div className={styles.optionsRow}>
              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  id="remember"
                  checked={formData.rememberMe}
                  onChange={(e) => handleChange('rememberMe', e.target.checked)}
                  className={styles.checkbox}
                  disabled={loading}
                />
                <label htmlFor="remember" className={styles.checkboxLabel}>
                  Remember me
                </label>
              </div>

              <Link to="/forgot" className={styles.forgotLink}>
                Forgot password?
              </Link>
            </div>

            <button 
              type="submit" 
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>

            <div className={styles.divider}>
              <span>or</span>
            </div>

            <div className={styles.footer}>
              Don't have an account? <Link to="/register" className={styles.link}>Sign up</Link>
            </div>
          </form>
        </div>
      </div>

      <div className={styles.rightSection}>
        <div className={styles.imageOverlay}></div>
      </div>
    </div>
  );
};

export default SignIn;